// ⚠️ Do NOT import this barrel from anything on the "/" render path (home
// deck, main-page) or from the game page. `export *` is not tree-shaken
// across the client-reference boundary: pulling one symbol from here drags
// RankList → DataTable → @dnd-kit (~75 KB raw) into that route's first-load
// JS even though RankList never renders there. Import the concrete module
// (api/getTopRankList, components/TopRankList, types, …) instead.
export * from "./types";
export * from "./api";
export * from "./hooks";
export * from "./actions";
export * from "./components";
export * from "./config";

